import { useEffect, useState } from "react";

export const TextArea = (props) => {
    const {style, className, cols, rows, id, onChange, value, onBlur, maxLength} = props;

    const [textarea, setTextarea] = useState("");

    useEffect(() => {
        setTextarea(value);
    }, [props]);

    const getValue = (e) => {
        setTextarea(e.target.value);
    }

    return (
        <textarea style={style} className={className} cols={cols} rows={rows} id={id} onBlur={onBlur} onChange={onChange ? onChange : getValue} value={textarea} maxLength={maxLength}/>
    );
}